const UPPERCASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
const LOWERCASE_CHARS = 'abcdefghijklmnopqrstuvwxyz'
const NUMBER_CHARS = '0123456789'
const SYMBOL_CHARS = '!@#$%^&*()-_=+[]{}<>?'

const ALL_CHARS = `${UPPERCASE_CHARS}${LOWERCASE_CHARS}${NUMBER_CHARS}${SYMBOL_CHARS}`

const getRandomInt = (max: number) => {
  const randomValues = new Uint32Array(1)
  crypto.getRandomValues(randomValues)
  return randomValues[0] % max
}

const pickRandomChar = (chars: string) => chars[getRandomInt(chars.length)]

export const generateSecurePassword = (minLength = 11, maxLength = 15): string => {
  const safeMin = Math.max(11, minLength)
  const safeMax = Math.max(safeMin, maxLength)
  const lengthRange = safeMax - safeMin + 1
  const passwordLength = safeMin + getRandomInt(lengthRange)

  const requiredChars = [
    pickRandomChar(UPPERCASE_CHARS),
    pickRandomChar(LOWERCASE_CHARS),
    pickRandomChar(NUMBER_CHARS),
    pickRandomChar(SYMBOL_CHARS)
  ]

  const remainingLength = passwordLength - requiredChars.length
  const randomChars = Array.from({ length: remainingLength }, () => pickRandomChar(ALL_CHARS))
  const mixedChars = [...requiredChars, ...randomChars]

  for (let i = mixedChars.length - 1; i > 0; i--) {
    const j = getRandomInt(i + 1)
    ;[mixedChars[i], mixedChars[j]] = [mixedChars[j], mixedChars[i]]
  }

  return mixedChars.join('')
}
